import { gql } from "@apollo/client";

export const GET_INDICATIONS_BY_EVALUACION = gql`
query GetIndicationsByIdEvaluacion ($idEvaluacion: Int!) {
    indicacionesRIByIdEvaluacion (idEvaluacion: $idEvaluacion) {
        idEvaluacionIndicacion
        cantidadDiaria
        idEvaluacion
        idInsumo
        idInsumoNavigation {
            descripcion
            eleccion
            idUnidadNavigation {
                alias
            }
        }
    }
}`;

export const adaptIndicacion = (indicacion) => {
  return {
    idEvaluacionIndicacion: indicacion?.idEvaluacionIndicacion,
    idInsumo: indicacion?.idInsumo,
    nombreInsumo: indicacion?.idInsumoNavigation?.descripcion,
    cantidadDiaria: indicacion?.cantidadDiaria,
    unidad: indicacion?.idInsumoNavigation?.idUnidadNavigation?.alias,
    eleccion: indicacion?.idInsumoNavigation?.eleccion
  };
};

export const adaptIndicacionesArray = (
indicaciones) =>
{
  return structuredClone(indicaciones?.indicacionesRIByIdEvaluacion)?.
  map((indicacion) => adaptIndicacion(indicacion));
};